import { state } from '@angular/animations';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environments';

export function initializer(keycloak: KeycloakService) {

  return () => keycloak.init({
    config: {
      url: environment.keycloak.issuer,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      flow: 'standard',
      checkLoginIframe: false,
    },
    bearerPrefix: 'KC-Bearer',


  })

}